import _omit from 'lodash/omit';
import type { WCardDesignFamilySummaryView } from '@zola/svc-web-api-ts-client';

export const getFullSuiteColors = (suite: WCardDesignFamilySummaryView): string[] => {
  const colors = Object.keys(suite.fullSuiteImageUrlByColor || {}).sort(
    (a, b) =>
      (suite.fullSuiteImageUrlByColor?.[a]?.position || 0) -
      (suite.fullSuiteImageUrlByColor?.[b]?.position || 0)
  );

  return colors;
};

export const getFullSuiteNrfColor = (
  nrfColor: Array<string>,
  suite: WCardDesignFamilySummaryView
): string => {
  if (!nrfColor) return '';
  let suiteColor = '';
  nrfColor.find(eachColor => {
    return (
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      Object.entries(suite.colorRecommendations).find(each => {
        if (each[0].toUpperCase() === eachColor) {
          suiteColor = each[1];
          return true;
        }
        return false;
      }) || false
    );
  });

  return suiteColor;
};

export const getFullSuiteDefaultColor = (suite: WCardDesignFamilySummaryView): string => {
  const [defaultColor] = getFullSuiteColors(suite);

  return defaultColor;
};

export const filterMapper = (filterObj: any): any => {
  const newFilters = {
    ...filterObj,
    has_letterpress: filterObj.is_letterpress || false,
    colors: [...(filterObj.seo_colors || [])],
  };

  return _omit(newFilters, ['seo_colors', 'is_letterpress']);
};

export const mapResponseToFilter = (filterObj: any): any => {
  const newFilters = {
    ...filterObj,
    has_letterpress: filterObj.is_letterpress || false,
  };

  return _omit(newFilters, ['is_letterpress']);
};
